import { AddressDetailsFragment } from 'generated/graphql';

export function addressWasChangedOnNormalization(address: AddressDetailsFragment) {
  if (!address?.normalized) {
    return false;
  }

  const a = address;
  const current = { city: a.city, state: a.state, zip: a.zip, streetAddress: a.streetAddress };
  const normalized = { city: a.original.city, state: a.original.state, zip: a.original.zip, streetAddress: a.original.streetAddress };

  // Compare normalized address to current address, if any of the fields are different, then it is not normalized
  // eslint-disable-next-line eqeqeq
  const allMatch = Object.keys(current).every(key => current[key] == normalized[key]);

  // Not all match, so it was changed on normalization
  return !allMatch;
}
